export { default } from './redis.provider';
export type { Redis } from 'ioredis';
